import { Assert } from '@cotera/utilities';
import { LlmColumnModel } from './llm-column.model';
import { createContext, useContext } from 'react';

export type Model = LlmColumnModel;

export const LlmModelContext = createContext<Model | null>(null);

export const useColumnModel = () => {
  const model = useContext(LlmModelContext);
  Assert.assert(model !== null, 'Column model not found');
  return model;
};
